<script>
    import { push } from 'svelte-spa-router';
    import CookbookService from '../server/service/CookbookService';
    import { newCookbook } from '../stores';

    const errMessage_emptyField = 'Field is empty';
    const errMessage_typeMismatch = 'Type mismatch';
    let currentErrMessage;

    function validate(event) {
        const input = event.target;
        if (input.value === '') {
            input.setCustomValidity(errMessage_emptyField);
            currentErrMessage = errMessage_emptyField;
        } else if (input.validity.typeMismatch) {
            input.setCustomValidity(errMessage_typeMismatch);
            currentErrMessage = errMessage_typeMismatch;
        } else {
            input.setCustomValidity('');
            currentErrMessage = undefined;
        }
    }

    function resetForm(form) {
        form.reset();
        const textarea = [...form.getElementsByTagName('textarea')];
        textarea.forEach(txt => {
            txt.value = '';
        });
    }

    async function handleSubmit(event) {
        const cookbook = JSON.stringify($newCookbook, 0, 2);
        resetForm(event.target);
        const response = await CookbookService.create(cookbook);
        console.log(response);

        if (response.status === 200) {
            push(`/cookbooks/${response.data.id}`);
        }
    }
</script>

<style>
    .content {
        width: 50%;
        margin: 0 auto;
    }
    form > * {
        width: 100%;
    }
    form > label {
        margin: 1em 0 .5em 0;
    }
    form > button[type="submit"] {
        margin-top: 2em;
    }
    input {
        width: 100%;
    }
    .err {
        margin: 0;
        color: red;
        font-style: italic;
    }
</style>

<h1>New Cookbook</h1>
<div class="content">
    <form on:submit|preventDefault={handleSubmit}>
        <label>Title</label>
        <input required on:submit={validate} on:formchange={validate} on:input={validate} on:change={validate} on:invalid={validate} bind:value={$newCookbook.title}>
        {#if currentErrMessage}
            <p class="err">{currentErrMessage}</p>
        {/if}

        <label>Description</label>
        <textarea bind:value={$newCookbook.description}></textarea>
    
        <br/>
        <button type="submit">Save</button>
    </form>
</div>